export default __webpack_public_path__ + "99b1192f03bafa8cd2eee84c13a86fef.png";